export default __webpack_public_path__ + "static/media/buy me food.0a2d54f7.png";